// Price helpers konnektive-core exposed as page globals (1.5.1).
//
// Core funnel scripts call them to draw package prices and the
// Subscribe & Save line, e.g. avinolpm's setPrices():
//   calculateDiscountedPrice(pkg.pricePerUnit, getConfig().discountSubscribe)
//
// Same signatures and maths as konnektive-core 0.4 utils.js: base is parsed
// as a float, the percentage as an integer.
//
// index.js puts these on window ONLY when the page has not defined them:
// many 1.5 funnels ship their own copies in app.js (some with different
// rounding), and those must keep winning whatever order the scripts load in.

export function calculateDiscountedPrice(base, amount) {
	const price = parseFloat(base);
	const percent = parseInt(amount, 10);
	return price - ((price * percent) / 100);
}

export function getDiscount(base, amount) {
	const price = parseFloat(base);
	const percent = parseInt(amount, 10);
	return (price * percent) / 100;
}
